<script lang="ts" setup>
import { computed, PropType } from "vue";
import { PoolDetails } from "@/models/pool-details.model";
import { getOutByIndex } from "@/shared/utils/outs";
import getSpeedCount from "@/shared/utils/misc/get-speed-count";
import { usePool } from "@/features/pool/usePool";

const props = defineProps({
  out: {
    type: Object as PropType<PoolDetails["outs"][number]>,
    required: true,
  },
});

defineEmits(["change"]);

// Special case for filtration (show ON VF1, VF2, etc…)
const outDef = getOutByIndex(props.out?.index);

const pool = usePool();
const showSpeed = computed(
  () => outDef.name === "OUT_FILTRE" && getSpeedCount(pool) > 0
);
</script>

<template>
  <div class="flex items-center">
    <div class="text-[10px] text-alert" v-if="out.status === 0">OFF</div>
    <div class="text-[10px] text-info" v-else-if="showSpeed">
      ON (VF{{ out.status }})
    </div>
    <div class="text-[10px] text-info" v-else-if="out.status === 1">ON</div>
  </div>
</template>
